module.exports = __webpack_public_path__ + "img/pdf.c4123c00.png";